module.exports = __webpack_public_path__ + "img/tema-3-21.b7b9afcc.svg";